import React, { useCallback } from 'react';
import Image from '../../../../common/image';

const CustomNode = ({ nodeDatum, toggleNode, onLabelClick }) => {
	const getImage = useCallback((data) => {
		if (!data.email) return '/images/userClass/none.svg';
		if (data.card === 'white') return '/images/userClass/white.svg';
		return `/images/userClass/${data.userClass}.svg`;
	}, []);

	return (
		<g>
			<circle
				r='16'
				fill='#00000000'
				stroke='#000'
				strokeWidth='1'
				onClick={toggleNode}
				style={{ cursor: 'pointer' }}
			/>
			<image
				href={getImage(nodeDatum.data)}
				x={-16} // half of the icon width, negative to center
				y={-16} // half of the icon height, negative to center
				width={32}
				height={32}
				style={{ pointerEvents: 'none' }} // lets clicks pass through to the circle
			/>
			<text
				fill='var(--font-color)'
				x='-25'
				dy='5'
				strokeWidth='0'
				style={{ fontSize: '12px', fontFamily: 'Arial', pointerEvents: 'none' }}>
				{nodeDatum.childrenCount}
			</text>

			<foreignObject
				x='20'
				y='-30'
				width='100'
				height='60'>
				<div
					xmlns='http://www.w3.org/1999/xhtml'
					style={{
						background: 'var(--cards-background)',
						border: '1px solid var(--font-color)',
						color: 'var(--font-color)',
						borderRadius: '3px',
						fontFamily: 'Roboto',
						fontSize: '12px',
						lineHeight: '20px',
						padding: '1px 5px',
						pointerEvents: 'all',
						cursor: 'pointer',
					}}
					onClick={(e) => {
						e.stopPropagation();
						onLabelClick(nodeDatum.data);
					}}>
					<div className='centerAll'>{nodeDatum.data?.id}</div>
					{nodeDatum.data.email && (
						<div className='d-flex justify-content-evenly align-items-center'>
							<Image
								height='35px'
								fileName={`diamonds/mmi_${nodeDatum.data?.mmiIsActive}.webp`}
							/>
							<Image
								height='35px'
								fileName={`diamonds/${nodeDatum.data?.card}.webp`}
							/>
						</div>
					)}
				</div>
			</foreignObject>
		</g>
	);
};

export default React.memo(CustomNode);
